<template>
  <div class="container">
    <Title>Organizations</Title>

    <!-- Form to Create a New Organization -->
    <div class="card-section">
      <h3>Create Organization</h3>
      <div class="org-form">
        <div class="form-grid">
          <div>
            <label for="org-name">Organization Name:</label>
            <input type="text" id="org-name" v-model="newOrganization.name" required />
          </div>

          <!-- 
          <div>
            <label for="org-address">Address:</label>
            <input type="text" id="org-address" v-model="newOrganization.address" required />
          </div>
          <div>
            <label for="org-website">Website:</label>
            <input type="text" id="org-website" v-model="newOrganization.website" />
          </div>
          <div>
            <label for="org-contact">Contact:</label>
            <input type="text" id="org-contact" v-model="newOrganization.contact" />
          </div>
          -->

          <div>
  <label for="org-address">Address:</label>
  <input type="text" id="org-address" v-model="newOrganization.address" disabled />
</div>
<div>
  <label for="org-website">Website:</label>
  <input type="text" id="org-website" v-model="newOrganization.website" disabled />
</div>
<div>
  <label for="org-contact">Contact:</label>
  <input type="text" id="org-contact" v-model="newOrganization.contact" disabled />
</div>



        </div>
        <button class="action-button primary-button" @click.prevent="addOrganization">Add Organization</button>
      </div>
    </div>

    <!-- Table of Organizations -->
    <div class="card-section">
      <h3>Organizations List</h3>
      <div class="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>Org ID</th>
              <th>Name</th>
              <th>Address</th>
              <th>Website</th>
              <th>Contact</th>
              <th>Status</th>
              <th>Edit</th>
              <th>Delete</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="org in organizations" :key="org.org_id">
              <td>{{ org.org_id }}</td>
              <td>
                <input v-if="isEditing && editingOrganization.org_id === org.org_id" v-model="editingOrganization.name"
                  class="table-input" />
                <span v-else>{{ org.name }}</span>
              </td>


            <!--   
              <td>
                <input v-if="isEditing && editingOrganization.org_id === org.org_id"
                  v-model="editingOrganization.address" class="table-input" />
                <span v-else>{{ org.address }}</span>
              </td>
              <td>
                <input v-if="isEditing && editingOrganization.org_id === org.org_id"
                  v-model="editingOrganization.website" class="table-input" />
                <span v-else>{{ org.website }}</span>
              </td>
              <td>
                <input v-if="isEditing && editingOrganization.org_id === org.org_id"
                  v-model="editingOrganization.contact" class="table-input" />
                <span v-else>{{ org.contact }}</span>
              </td>
            -->
<td>
  <input v-if="isEditing && editingOrganization.org_id === org.org_id"
    v-model="editingOrganization.address" class="table-input" disabled />
  <span v-else>{{ org.address }}</span>
</td>
<td>
  <input v-if="isEditing && editingOrganization.org_id === org.org_id"
    v-model="editingOrganization.website" class="table-input" disabled />
  <span v-else>{{ org.website }}</span>
</td>
<td>
  <input v-if="isEditing && editingOrganization.org_id === org.org_id"
    v-model="editingOrganization.contact" class="table-input" disabled />
  <span v-else>{{ org.contact }}</span>
</td>


              <td>
                <button class="status-button" :class="org.status ? 'active' : 'inactive'" @click="toggleStatus(org)">
                  {{ org.status ? 'Active' : 'Inactive' }}
                </button>
              </td>
              <td>
                <button v-if="isEditing && editingOrganization.org_id === org.org_id" class="action-button save-button"
                  @click="updateOrganization">Save</button>
                <button v-else class="action-button edit-button" @click="editOrganization(org)">Edit</button>
              </td>
              <td>
                <button v-if="isEditing && editingOrganization.org_id === org.org_id"
                  class="action-button cancel-button" @click="cancelEdit">Cancel</button>
                <button v-else class="action-button delete-button" @click="confirmDelete(org.org_id)">Delete</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Confirmation Dialog Box -->
    <div v-if="showDialog" class="dialog-overlay">
      <div class="dialog-box">
        <p>{{ dialogMessage }}</p>
        <div class="dialog-buttons">
          <button @click="dialogConfirm" class="action-button primary-button">OK</button>
          <button @click="dialogCancel" class="action-button delete-button">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import apiService from '@/services/apiService';
import Title from './components/Title.vue';

export default {
  components: {
    Title
  },
  data() {
    return {
      organizations: [],
      newOrganization: {
        name: '',
        address: '',
        website: '',
        contact: '',
      },
      isEditing: false,
      editingOrganization: {},
      showDialog: false, // Track whether the dialog is open
      dialogMessage: '', // Store the message for the dialog
      orgToDelete: null, // Store the organization ID to be deleted
    };
  },
  mounted() {
    this.fetchOrganizations();
  },
  methods: {
    async fetchOrganizations() {
      try {
        this.organizations = await apiService.fetchOrganizations();
      } catch (error) {
        console.error("Failed to fetch organizations:", error);
      }
    },
    async addOrganization() {
      try {
        const newOrg = await apiService.createOrganization(this.newOrganization);
        this.organizations.push(newOrg);
        this.newOrganization = { name: '', address: '', website: '', contact: '' };
      } catch (error) {
        console.error("Failed to save organization:", error);
        alert('Failed to create organization. Please try again.');
      }
    },
    toggleStatus(org) {
      org.status = !org.status;
    },
    editOrganization(org) {
      this.isEditing = true;
      this.editingOrganization = { ...org };
    },
    async updateOrganization() {
      try {
        await apiService.updateOrganization(this.editingOrganization.org_id, this.editingOrganization);

        // Refetch organizations to refresh the table
        await this.fetchOrganizations();

        this.cancelEdit();
      } catch (error) {
        console.error("Failed to update organization:", error);
        alert('Failed to update organization. Please try again.');
      }
    },
    confirmDelete(orgId) {
      // Set the ID of the organization to be deleted and show dialog
      this.orgToDelete = orgId;
      this.dialogMessage = 'Are you sure you want to delete this organization?';
      this.showDialog = true;
    },
    async dialogConfirm() {
      // Proceed to delete the organization
      if (this.orgToDelete !== null) {
        try {
          await apiService.deleteOrganization(this.orgToDelete);
          this.organizations = this.organizations.filter(org => org.org_id !== this.orgToDelete);
        } catch (error) {
          console.error("Failed to delete organization:", error);
          alert('Failed to delete organization. Please try again.');
        }
      }
      // Reset dialog state
      this.showDialog = false;
      this.orgToDelete = null;
    },
    dialogCancel() {
      // Close the dialog without deleting the organization
      this.showDialog = false;
      this.orgToDelete = null;
    },
    cancelEdit() {
      this.isEditing = false;
      this.editingOrganization = {};
    },
  },
};
</script>



<style scoped>
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 1.5rem;
  font-family: 'Montserrat', 'Avenir', Helvetica, Arial, sans-serif;
  color: #323232;
}

.title {
  color: #323232;
  font-size: 1.8rem;
  margin-bottom: 1.5rem;
  font-weight: 600;
  border-bottom: 2px solid #42b983;
  padding-bottom: 0.5rem;
  display: inline-block;
}

.card-section {
  background-color: white;
  border-radius: 6px;
  border: 0.5px solid #bbf0db;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
}

.card-section-create {
  border: 0.5px solid #42b983;
}

h3 {
  color: #323232;
  font-size: 1.2rem;
  margin-bottom: 1rem;
  font-weight: 600;
}

.form-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 0.8rem;
  align-items: start;
}

input {
  padding: 8px 10px;
  border: 1px solid #e8e9f5;
  border-radius: 4px;
  font-size: 14px;
  transition: border-color 0.2s ease;
  height: 36px;
}

input:focus {
  outline: none;
  border-color: #505050;
}

.table-wrapper {
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #e8e9f5;
}

table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  font-size: 14px;
}

th,
td {
  padding: 10px 12px;
  text-align: left;
  border-bottom: 1px solid #e8e9f5;
  font-weight: 500;

}

th {
  background-color: #e8f4f0;
  font-weight: 700;
  color: #323232;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

tr:last-child td {
  border-bottom: none;
}

tr:hover {
  background-color: #f9f9f9;
}

.action-button {
  min-width: 80px;
  height: 32px;
  padding: 0 12px;
  border-radius: 4px;
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  border: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.primary-button {
  background-color: #42b983;
  height: 100%;
  color: white;
}

.primary-button:hover {
  background-color: #2E7D32;
}

.edit-button {
  background-color: #f6f6f6;
  color: #323232;
}

.edit-button:hover {
  background-color: #e8e8e8;
}

.save-button {
  background-color: #42b983;
  color: white;
}

.save-button:hover {
  background-color: #2E7D32;
}

.delete-button {
  background-color: #f8d7da;
  color: #dc3545;
}

.delete-button:hover {
  background-color: #f5c6cb;
}

.cancel-button {
  background-color: #e8e8e8;
  color: #323232;
}

.cancel-button:hover {
  background-color: #d8d8d8;
}

.status-button {
  min-width: 80px;
  height: 28px;
  padding: 0 10px;
  border-radius: 14px;
  font-weight: 600;
  font-size: 12px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  border: none;
}

.status-button.active {
  background-color: #d4edda;
  color: #42b983;
}

.status-button.inactive {
  background-color: #f8d7da;
  color: #dc3545;
}

.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(2px);
}

.dialog-box {
  background-color: white;
  padding: 1.5rem;
  border-radius: 6px;
  width: 350px;
  border: 1px solid #e8e9f5;
}

.dialog-box p {
  margin-bottom: 1rem;
  color: #323232;
}

.dialog-buttons {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 1rem;
}

.table-input {
  width: 100%;
  max-width: 150px;
  box-sizing: border-box;
}

/* New Organization Form Styles */
.org-form {
  background-color: white;
  border-radius: 6px;
  border: 0.5px solid #42b983;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
}

.org-form label {
  display: block;
  color: #323232;
  font-size: 14px;
  margin-bottom: 0.5rem;
  font-weight: 500;
}

.org-form input {
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #e8e9f5;
  border-radius: 4px;
  font-size: 14px;
  transition: border-color 0.2s ease;
  height: 36px;
  margin-bottom: 1rem;
  box-sizing: border-box;
}

.org-form input:focus {
  outline: none;
  border-color: #42b983;
}

.org-form button {
  min-width: 120px;
  height: 36px;
  padding: 0 16px;
  border-radius: 4px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  border: none;
  background-color: #42b983;
  color: white;
  display: block;
  margin-top: 1rem;
}

.org-form button:hover {
  background-color: #2E7D32;
}

/* Responsive grid for form */
@media (min-width: 768px) {
  .org-form .form-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
  }
}
</style>